import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import JsonViewer from './JsonViewer-dataapi';
import PDFViewer from './pdf';
import MenuComponent from './MenuComponent';
//import { Buffer } from 'buffer';
//window.Buffer = Buffer;
//import PdfViewer from './muti-view';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const jsonUrl = 'http://localhost:3010/large-json';
root.render(
  <React.StrictMode>
     <MenuComponent />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
